import { DocumentType } from "../../../@types/enumsGlobal"
import { appendTabWithSelection } from "../../functions/appendTabWithSelection"


interface IGridContextState {
    selectedItem?: ISelectGridRow
    selectedItemDetail?: ISelectGridRow
    document?: DocumentType
    view?: boolean
    idTab?: string
}

type IGridContextAction =
      { type: 'select', payload: { item: ISelectGridRow, document: DocumentType, idTab: string } } 
    | { type: 'selectDetail', payload: { item: ISelectGridRow } }
    | { type: 'unselect', payload: { idTab: string } }
    | { type: 'unselectDetail' }
    | { type: 'refresh', payload: boolean }

export const defaultGridContextState: IGridContextState = {}

export function gridContextReducerHandler(state: IGridContextState, action: IGridContextAction) {

    // Добавляем связку 'id вкладки' -> 'id выделенной строки'
    if (action.type === 'select' && action.payload.item && state.idTab)
        appendTabWithSelection(state.idTab, action.payload.item?.idGlobal);
    
    switch (action.type) {
        case 'select': return { ...state, selectedItem: action.payload.item, document: action.payload.document, idTab: action.payload.idTab } as IGridContextState 
        case 'selectDetail': return { ...state, selectedItemDetail: action.payload.item}
        case 'unselect': return { ...state, selectedItem: undefined, document: undefined, idTab: action.payload.idTab } as IGridContextState
        case 'unselectDetail': return { ...state, selectedItemDetail: undefined, document: undefined }
        case 'refresh': return { ...state, view: action.payload }

        default:
            return state
    }
}